import './Footer.css';
import spottIconLarge from '../../../../assets/spott-icon-gray.png';

export const Footer = () => {
  return (
    <div className='footer-container'>
      <span>
        Plugado na
      </span>
      <img
        src={spottIconLarge}
        alt={`${spottIconLarge}`}
        className="spott-icon"
      />
    </div>
  )
}